import { UpdateContactCommentDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workOrderApi } from "../service";
import { applyContactResult } from "./contactMutationSuccess";

/** Sets the Auftrag's one contact comment; `comment: ""` clears it. */
export function useUpdateContactComment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workOrderId, dto }: { workOrderId: string; dto: UpdateContactCommentDto }) => {
      const { data } = await workOrderApi.updateContactComment(workOrderId, dto);
      return data;
    },
    onSuccess: (data, { workOrderId }) => applyContactResult(queryClient, workOrderId, data),
  });
}
